import * as prometheus from '../tracking/prometheus';

export function postMessageToParent(message: object) {
    const isInIframe = window.parent !== window;

    if (window.postMessage && isInIframe) {
        const content = JSON.stringify(message);
        setTimeout(() => {
            window.parent.postMessage(content, '*');
        }, 100);
    }
}

export function getDimensions() {
    const height = Math.max(
        document.body.clientHeight,
        document.body.offsetHeight || 0
    );
    const width = Math.max(
        document.body.clientWidth,
        document.body.offsetWidth || 0
    );
    return {
        height,
        width,
    };
}

export function sendHeightToParent() {
    const height = getDimensions().height;
    const message = {
        height,
    };
    postMessageToParent(message);
}

export function notifyParent(match: boolean) {
    prometheus.logViewCount(match);
    const message = {
        match,
    };
    postMessageToParent(message);
}
